if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      this.submitButton = this.querySelector('[type="submit"]');
      if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

      // The <span> that holds the visible button label (e.g. "Add to cart").
      // Used for the Adding... / Added states.
      this.submitButtonText = this.submitButton ? this.submitButton.querySelector('span') : null;
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      this.handleErrorMessage();

      // Remember the original label once, so we can always reset back to it.
      if (this.submitButtonText && this.defaultButtonText == null) {
        this.defaultButtonText = this.submitButtonText.textContent.trim();
      }
      // If a previous "Added" reset is still pending, cancel it.
      if (this.resetTimer) clearTimeout(this.resetTimer);

      this.submitButton.setAttribute('aria-disabled', true);
      this.setButtonText('Adding...');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);
      // We only need the header cart count to refresh — no notification popup.
      formData.append('sections', 'cart-icon-bubble');
      formData.append('sections_url', window.location.pathname);
      config.body = formData;

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            this.handleErrorMessage(response.description);
            this.setButtonText(this.defaultButtonText);

            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (!soldOutMessage) return;
            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButton.querySelector('span').classList.add('hidden');
            soldOutMessage.classList.remove('hidden');
            this.error = true;
            return;
          }

          this.error = false;

          // Refresh the header cart count without opening any notification/drawer popup.
          this.updateCartCount(response);

          // If this form lives inside a quick-add modal, just close it.
          const quickAddModal = this.closest('quick-add-modal');
          if (quickAddModal) {
            quickAddModal.hide(true);
            return;
          }

          // Button feedback: Added -> reset to original after 2 seconds.
          this.setButtonText('Added');
          this.resetTimer = setTimeout(() => this.setButtonText(this.defaultButtonText), 2000);
        })
        .catch((e) => {
          console.error(e);
          this.setButtonText(this.defaultButtonText);
        })
        .finally(() => {
          if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          if (!this.error) this.submitButton.removeAttribute('aria-disabled');
        });
    }

    // Sets the visible button label (no-op if the button has no label span).
    setButtonText(text) {
      if (this.submitButtonText && text != null) this.submitButtonText.textContent = text;
    }

    // Updates the header cart-count bubble from the add.js sections response.
    updateCartCount(response) {
      if (!response.sections || !response.sections['cart-icon-bubble']) return;
      const bubble = document.getElementById('cart-icon-bubble');
      if (!bubble) return;
      const node = new DOMParser()
        .parseFromString(response.sections['cart-icon-bubble'], 'text/html')
        .querySelector('.shopify-section');
      if (node) bubble.innerHTML = node.innerHTML;
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}
